import { Star } from "lucide-react";
import { Reveal } from "./Reveal";

const REVIEWS = [
  {
    quote:
      "Two nor'easters since the install and not a drop in the basement. The French drain and new downspout lines were worth every penny.",
    name: "Marcus T.",
    where: "Cherry Hill, NJ",
    job: "Waterproofing + Downspouts",
  },
  {
    quote:
      "They measured, quoted and installed seamless gutters in five days flat. Crew was on time, spotless cleanup, price matched the quote exactly.",
    name: "Dana W.",
    where: "Wilmington, DE",
    job: "Seamless Gutters",
  },
  {
    quote:
      "Three other companies quoted band-aid fixes. D&G found the real grading issue and fixed it once. Should have called them first.",
    name: "Priya S.",
    where: "Doylestown, PA",
    job: "Full System Shield",
  },
];

export const Testimonials = () => (
  <section id="testimonials" className="py-20 lg:py-32" data-testid="testimonials-section">
    <div className="mx-auto max-w-7xl px-4 sm:px-8">
      <Reveal>
        <p className="mb-4 font-mono text-xs font-bold uppercase tracking-[0.3em] text-orange-500">
          Word From The Block
        </p>
        <h2 className="max-w-3xl font-display text-4xl font-extrabold uppercase leading-[0.95] text-white sm:text-5xl lg:text-6xl">
          Neighbors Who <span className="text-outline">Stayed Dry</span>
        </h2>
      </Reveal>
      <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-3">
        {REVIEWS.map((r, i) => (
          <Reveal key={r.name} delay={i * 0.12}>
            <blockquote
              className="flex h-full flex-col rounded-2xl border border-white/10 bg-ink2 p-6 transition-all duration-300 hover:-translate-y-1.5 hover:border-orange-500/40 sm:p-8"
              data-testid={`testimonial-card-${i}`}
            >
              <div className="flex gap-1">
                {[...Array(5)].map((_, s) => (
                  <Star key={s} className="h-4 w-4 fill-orange-500 text-orange-500" />
                ))}
              </div>
              <p className="mt-5 flex-1 text-sm leading-relaxed text-slate-300 sm:text-base">
                "{r.quote}"
              </p>
              <footer className="mt-6 border-t border-white/10 pt-4">
                <p className="font-display text-lg font-bold uppercase text-white">{r.name}</p>
                <p className="text-xs text-slate-500">
                  {r.where} — {r.job}
                </p>
              </footer>
            </blockquote>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
